function UIElement(x,y, type, params, id, folderwide, place_id) {
	//this.x = parseInt(x);
	//this.y = parseInt(y);
	if (folderwide == undefined) folderwide = 0;
	this.id = id;	
	this.place = place_id;
	this.type = (type == undefined ? 0 : type);
	this.folderwide = folderwide; // (folderwide == "true" || folderwide == "1" || folderwide == 1) ? true : false;
	this.params = (params == undefined ? {} : params);
	this.uid = Date.now() + "-" + Math.round(Math.random() * 10000);
	this.node = $("<div class='uielement'><div class='container'><div style='background-color:#ffffff;color:#000000;padding:20px'>uielement</div></div></div>");

	if (this.params.screen == undefined) this.params.screen = {"w": $(document).width(), "h": $(document).height()};

	if (this.params.layer == undefined) this.params.layer = 1;

	this.erp = new Interpolate();
	
	if (Screen.md() || Screen.lg() || (this.type == 2 && this.params.hideui != true && this.params.hideui != "true")) $("#elements").append(this.node);

	if (player.cms) this.editor = new UIElementEdit(this);

	if (type != undefined && params != undefined) {
		this.build(params);
	}

	this.setLayer(this.params.layer);

	this.calculateCoords(x,y);
	this.update();

	var self = this;
	$(window).resize(function() {
		//console.log(self.x + ", " + self.y);
		//console.log(self.params.valign);
		self.calculateCoords(self.originX, self.originY);
		self.update();
	});
}

UIElement.prototype = {

	close: function() {
		this.node.hide();
		Tab.disable('elements', this.ytclose_tab.id);
		Tab.disable('elements', this.player_tab.id);

		YTPlayer.api(this.ytid).pauseVideo();
		MediaWidget.showIcon(this);
	},

	calculateCoords: function(x, y) {
		this.originX = x;
		this.originY = y;

		this.percentX = parseInt(x);
		this.percentY = parseInt(y);

		if (this.params.fullscreen == true || this.params.fullscreen == "true") {
			this.x = 0;
			this.y = 0;
			return;
		}

		x = parseInt(x);
		y = parseInt(y);

		var nw = 0;
		var nh = 0;

		if (this.params == undefined || this.params.size == undefined || this.params.size.width == undefined) nw = this.node.width();
		else nw = parseInt(this.params.size.width);

		if (this.params == undefined || this.params.size == undefined || this.params.size.height == undefined) nh = this.node.height();
		else nh = parseInt(this.params.size.height);

		if (this.params != undefined) {
			if (this.params.align == 'r') {
				x = $("#player").width() - x - nw;
				this.percentX = parseInt(this.originX) + nw;
			} else if (this.params.align == 'c') {
				x = ($("#player").width() * 0.5) - (nw * 0.5);
			}

			if (this.params.valign == 'b') {
				y = $("#player").height() - y - nh;
				this.percentY = parseInt(this.originY) + nw;
			} else if (this.params.valign == 'm') {
				y = ($("#player").height() * 0.5) - (nh * 0.5);
			}
		}


		this.x = x;
		this.y = y;
	},

	update: function(dragging) {
		if (dragging) {
			this.params.size = {"width": this.node.width(), "height": this.node.height()};			
		}

		if (this.params.fullscreen != true && this.params.fullscreen != "true") {

			if (dragging || this.params.coords == "px" || this.params.coords == undefined) {		
				this.node.css("left", this.x + "px");
				this.node.css("top", this.y + "px");
			} else {

				var cx = this.percentX * ($("#player").width() / this.params.screen.w);


				if (this.params.align == 'r') {
					this.node.css("left", $("#player").width() - cx + "px");
				} else {
					this.node.css("left", cx + "px");
				}

				var cmargin = 0.5 * ($("#player").height() - ($("#player").width() * 0.5));
				var omargin = 0.5 * (this.params.screen.h - this.params.screen.w * 0.5);

				var rely = this.percentY - omargin;
				var cy = rely * ($("#player").width() / this.params.screen.w);
				var sh = cmargin + $("#player").width() * 0.5;

				if (this.params.valign == 'b') {
					this.node.css("top", sh - cy + "px");
				} else {
					this.node.css("top", cmargin + cy + "px");
				}
			}
			
		}

//		if (dragging) this.params.size = {"width": this.node.width(), "height": this.node.height()};
	},

	hpos: function() {
		if (this.params.align != undefined) {
			if (this.params.align == 'r') {
				if (this.params == undefined || this.params.size == undefined || this.params.size.width == undefined) return $("#player").width() - (this.x + this.node.width());
				else return $("#player").width() - (this.x + this.params.size.width);
			}
			if (this.params.align == 'c') {
				return 0;
			}
		}

		return this.x;
	},

	vpos: function() {
		if (this.params.valign != undefined) {
			if (this.params.valign == 'b') {
//				return $("#player").height() - (this.y + this.node.height()) - ($("#player").height() - $("#player").width() * 0.5);
//				return $("#player").height() - this.y + (($("#player").height() - $("#player").width() * 0.5));
				var res = 0;
				if (this.params == undefined || this.params.size == undefined || this.params.size.height == undefined) res = $("#player").height() - (this.y + this.node.height());
				else res = $("#player").height() - (this.y + this.params.size.height);

				return res;
			}
			if (this.params.valign == 'm') {
				return 0;
			}
		}

		return this.y;
	},

	getEmbedInfo: function (url) {

        url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

        if (RegExp.$3.indexOf('youtu') > -1) {
            var type = 'youtube';
        } else if (RegExp.$3.indexOf('vimeo') > -1) {
            var type = 'vimeo';
        }else{
            return false;
        }

        var data = {
            url: url,
            type: type,
            id: RegExp.$6,
            embedUrl: "//www.youtube.com/embed/" + RegExp.$6
        };

        return data;
    }, 

	getEmbedUrl: function (url) {

		var d = this.getEmbedInfo(url);

        return d.embedUrl;
    }, 

    verify: function(t, p) {
    	var d = [t,p];
    	return JSON.stringify(d);
    },

    refresh: function() {
		if (this.type == 3) {
			if (this.params.muted == undefined) this.params.muted = true;
			if (Screen.xs()) {
				var qstr = "?rel=0&";
				if (this.params.start != undefined && this.params.start > 0) qstr += "start=" + this.params.start + "&";
				if (this.params.autostart == true) qstr += "autoplay=1&";
				if (this.params.muted == undefined || this.params.muted == true) qstr += "mute=1&";
				MediaWidget.addMediaUrl(this.getEmbedInfo(this.params.yturl), qstr);
			}
		}
    },

    animTrans: function(p, n) {
    	var img = this.node.find(".container img");

    	var nop = parseFloat(img.eq(n).css("opacity"));
   		var pop = parseFloat(img.eq(p).css("opacity"));

    	if (nop < 1) {
    		img.eq(n).css("opacity", nop + 0.1);
    	} else {
    		if (pop > 0) img.eq(p).css("opacity", pop - 0.1);
    	}

    	var self = this;
    	if (nop < 1 || pop > 0) setTimeout(function() {self.animTrans(p, n);}, 20);
    },

    animationCycle: function() {
    	var frame = this.params.frames[this.currentAnimationFrame];
    	var self = this;

    	this.animationTimer = setTimeout(function() {
    		var prvframe = self.currentAnimationFrame;
    		self.currentAnimationFrame ++;
    		if (self.currentAnimationFrame >= self.params.frames.length) self.currentAnimationFrame = 0;

    		self.animTrans(prvframe, self.currentAnimationFrame);

//    		self.node.find(".container img").attr("src", "/storage/library/" + player.current.folder.city_id + "/" + self.params.frames[self.currentAnimationFrame].image);
    		self.animationCycle();
    	}, frame.delay * 1000 * this.params.speed);
    },

    resetAnimations: function() {
    	this.animationPlayed = null;
    },

    skipAnimation: function() {
    	return player.cms == "1" && this.animationPlayed;
    },

    animate: function(stage, params) {
    	if (stage == "start") {
    		if (params.start_anim == undefined || params.start_anim == "none" || this.skipAnimation()) {
				this.node.show();
			} else if (params.start_anim == "fadein") {
				this.animationPlayed = true;

				//console.log("reset");
				this.node.css("opacity", 0);
				this.erp.setStart({"opacity": 0});
				this.erp.setEnd({"opacity": 1});
				this.erp.reset();

				this.animtimer = setInterval(function() {
					this.erp.next(0.3);
					var o = this.erp.cycleProperty("opacity", "easeOutCubic");
					this.node.css("opacity", o);

					if (this.erp.pos >= 1) clearInterval(this.animtimer);

				}.bind(this), 1000 / 30);

				this.node.show();
			}
		}
    },

	build: function(params) {
		this.node.hide();

		if (params.delay != undefined && parseInt(params.delay) != 0  && !this.skipAnimation()) {
			setTimeout(function() {
				this.node.show();
				this.create(params);
				this.animate("start", params);
				this.calculateCoords(this.originX, this.originY);
				this.update();
			}.bind(this), params.delay * 1000);
		} else {
			this.create(params);
			this.animate("start", params);
		}
	},

	create: function(params) {
		this.params = params;

		if (this.verification != this.verify(this.type, params)) {
			if (this.type == 4) {
				//console.log("build html: " + this.params.html);
				if (this.lasthtml != this.params.html) {
					this.node.find(".container").html(this.params.html);
					this.lasthtml = this.params.html;
				}
			}

			if (this.type == 1) {
//				console.log(params.frames);
				var preimg = new Image();
				var self = this;
				preimg.onload = function() {
					self.calculateCoords(self.originX, self.originY);
					self.update();
				};

				var prefix = '';
				if (player.offline) {
					prefix = '.';
					preimg.src = "./storage/library/" + player.current.folder.city_id + "/" + params.frames[0].image;
				} else {
					preimg.src = "/storage/library/" + player.current.folder.city_id + "/" + params.frames[0].image;
				}

				for(var f in params.frames) {
					if (f == 0) this.node.find(".container").html("<img src='" + prefix + "/storage/library/" + player.current.folder.city_id + "/" + params.frames[0].image + "'>");
					else this.node.find(".container").append($("<img src='" + prefix + "/storage/library/" + player.current.folder.city_id + "/" + params.frames[f].image + "' style='position: absolute; opacity:0;left:0px;top:0px;'>"));
				}

				this.currentAnimationFrame = 0;
				if (this.animationTimer != undefined) clearTimeout(this.animationTimer);
				this.animationCycle();

			}

			if (this.type == 3) {
				if (this.params.muted == undefined) this.params.muted = true;
				if (Screen.xs()) {
					var qstr = "?rel=0&";
					if (this.params.start != undefined && this.params.start > 0) qstr += "start=" + this.params.start + "&";
					if (this.params.autostart == true) qstr += "autoplay=1&";
					if (this.params.muted == undefined || this.params.muted == true) qstr += "mute=1&";
					MediaWidget.addMediaUrl(this.getEmbedInfo(this.params.yturl), qstr);
				} else {
					var vw = this.params.width == undefined ? 450 : this.params.width;
					var vh = this.params.height == undefined ? 220 : this.params.height;
					var qstr = "?rel=0&";
					if (this.params.start != undefined && this.params.start > 0) qstr += "start=" + this.params.start + "&";
					if (this.params.autostart == true) qstr += "autoplay=1&";
					if (this.params.muted == undefined || this.params.muted == true) qstr += "mute=1&";
					if (this.params.yturl != undefined) {
						//this.node.find(".container").html("<iframe src='" + this.getEmbedUrl(this.params.yturl) + qstr + "' frameborder='0' width='" + vw + "' height='" + vh + "' allow='autoplay' allowfullscreen></iframe>");

						var ei = this.getEmbedInfo(this.params.yturl);

						this.node.find(".container").html("<div id='yt-uie-iframe-" + this.id + "'></div>");

						this.ytid = YTPlayer.embed('yt-uie-iframe-' + this.id, ei.id, vw, vh);
						//console.log(YTPlayer.api(this.ytid));

						if (this.params.muted) {
							setTimeout(function() {
								Volume.yt.set(0);
							}, 3005);
						}

						if (this.params.autostart == true) {
							var self = this;
							setTimeout(function() {
								//console.log(self.ytid);
								//console.log(YTPlayer.api(self.ytid));
								YTPlayer.api(self.ytid).playVideo();
							}, 3000);
						}

						this.node.find(".container").append($("<a href='javascript:void(null)' class='ytclose' id='ytclose-" + this.id + "' title='" + TPL.lng("tips.clicktocloseyt", "Kliknij aby zamknąć film youtube") + "'>&times;</a>"));
						
						this.ytclose_tab = Tab.add('elements', {
							"focus": function(m) {
								m.node.addClass("focused");
								if (m.focus == undefined) m.node.focus();
								else m.focus.focus();
							},

							"blur": function(m) {
								m.node.removeClass("focused");
							},

						}, {"node": $("#ytclose-" + this.id)});

						this.player_tab = Tab.add('elements', {
							"focus": function(m) {
								m.node.addClass("focused");
								if (m.focus == undefined) m.node.focus();
								else m.focus.focus();
							},

							"blur": function(m) {
								m.node.removeClass("focused");
							},

							"keyboard": function(m, event) {
								//console.log(event.key);
								if (event.key == " ") {
									if (YTPlayer.api(m.ytid).getPlayerState() == 1)
										YTPlayer.api(m.ytid).pauseVideo();
									else
										YTPlayer.api(m.ytid).playVideo();
								}
							}

						}, {"node": this.node, "ytid": this.ytid});


						var self = this;
						$("#ytclose-" + this.id).click(function() {
							self.node.hide();
							Tab.disable('elements', self.ytclose_tab.id);
							Tab.disable('elements', self.player_tab.id);

							YTPlayer.api(self.ytid).pauseVideo();
							MediaWidget.showIcon(self);							
						});
					}
					this.node.css("width", vw + "px");
					this.node.css("height", vh + "px");
				}
			} else if (this.type == 2) {
				if (this.params.videourl != undefined) {
					this.vplayer = new vplayer(player.cms == "1" ? true : undefined);
					this.node.find(".container").html(this.vplayer.embed());

					if (this.params.fullscreen == true || this.params.fullscreen == "true") {
						this.node.css("width", "100%");
						this.node.css("height", "100%");
						this.node.css("left", "50%");
						this.node.css("top", "50%");
						this.node.css("transform", "translate(-50%, -50%)");
						this.vplayer.setSize("100%", "100%");
						if (player.cms != "1") {
							this.node.css("pointer-events", "none");
							this.node.find(".video-player").css("pointer-events", "none");
						}
					}

					if (this.params.hideui == true || this.params.hideui == "true") {
					} else {
						this.node.find(".container").append($("<a href='javascript:void(null)' class='ytclose' id='vidclose-" + this.id + "' title='" + TPL.lng("tips.clicktocloseyt", "Kliknij aby zamknąć film") + "'>&times;</a>"));
					}

					var defx = 450;
					var defy = 220;

					if (this.params.units == "%") {
						defx = 30;
						defy = 30;
					}

					var vw = this.params.width == undefined ? defx : this.params.width;
					var vh = this.params.height == undefined ? defy : this.params.height;

					if (this.params.fullscreen == true || this.params.fullscreen == "true") {
						this.vplayer.setFullscreen(true);
					} else {
						this.vplayer.setFullscreen(false);
						this.vplayer.setSize(vw, vh, this.params.units, true);
					}

					if (this.params.noevents == true || this.params.noevents == "true") {
						if (player.cms != "1") {
							this.node.css("pointer-events", "none");
							this.node.find(".video-player").css("pointer-events", "none");
						}
					} else {
						if (player.cms != "1") {
							this.node.css("pointer-events", "all");
							this.node.find(".video-player").css("pointer-events", "all");
						}
					}

					if (player.offline) {
						this.params.videourl = this.params.videourl.replace('https://www.wkraj.pl', '.');
					}

					var prefix = '';
					if (player.offline) {
						prefix = '.';
					}
					
					player.current.folder.city_id
					var url = "";
					if (this.params.videourl.substr(0, 4) == "http") url = this.params.videourl;
					else url = prefix + "/storage/library/" + player.current.folder.city_id + this.params.videourl;

					//console.log(this.params.videourl.substr(0, 4));

					this.vplayer.load(url);
					var self = this;

					if (this.params.loop == true || this.params.loop == "true") {
						this.vplayer.setLoop(true);
					} else {
						this.vplayer.setLoop(false);
					}

					if (this.params.hideui == true || this.params.hideui == "true") {
						this.vplayer.toggleUI(false);
					} else {
						this.vplayer.toggleUI(true);						
					}

					if (this.params.opacity != undefined) {
						this.vplayer.setOpacity(this.params.opacity);
					} else {
						this.params.opacity = 100;
						this.vplayer.setOpacity(100);
					}

					if (MediaWidget.getIconStatus("vid") || Screen.xs()) {

						this.node.hide();
						if (this.params.hideui == true || this.params.hideui == "true") {
						} else {
							setTimeout(function() {
								MediaWidget.showIcon(self, "<img src='assets/deaf.png' width='42'>", TPL.lng("tips.signlanguage", "Język migowy"), "vid");
							}, 200);
						}
					} else {						
						if (this.params.autostart == true || this.params.autostart == "true") {
							self.vplayer.autostart(true);
							//setTimeout(function() {self.vplayer.play();}, 100);
						} else {
							self.vplayer.autostart(false);
						}
					}

					$("#vidclose-" + this.id).click(function() {

						self.node.hide();
						//Tab.disable('elements', self.ytclose_tab.id);
						//Tab.disable('elements', self.player_tab.id);

						//YTPlayer.api(self.ytid).pauseVideo();
						self.vplayer.stop()
						MediaWidget.showIcon(self, "<img src='assets/deaf.png' width='42'>", TPL.lng("tips.signlanguage", "Język migowy"), "vid");
					});

					//this.node.find(".container").html("<video src='" + this.params.videourl + "' controls></video>");
				}
			}

			this.verification = this.verify(this.type, params);

			if (player.cms) this.editor.update();
		}
	},

	setLayer: function(l) {
		this.params.layer = l;
		this.node.css("z-index", this.params.layer);
	},

	destroy: function() {
		MediaWidget.showIcon(null);
		this.node.remove();

		if (this.ytclose_tab != undefined) Tab.remove('elements', this.ytclose_tab.id);
		if (this.player_tab != undefined) Tab.remove('elements', this.player_tab.id);
	}
}